import React from 'react';
import classnames from 'classnames';
import styles from './Detail.module.scss';

interface Props {
  label: string;
  value: any;
  isHighlighted?: boolean;
  isHtml?: boolean;
}

const Detail = ({ label, value, isHighlighted, isHtml }: Props) => {
  if (label) {
    return (
      <div className={classnames(styles.Detail, 'details')}>
        <div className={styles.label}>{label}</div>
        {isHtml ? (
          <div
            className={classnames(
              styles.value,
              isHighlighted && styles.highlighted,
            )}
            dangerouslySetInnerHTML={{ __html: value }}
          />
        ) : (
          <div
            className={classnames(
              styles.value,
              isHighlighted && styles.highlighted,
            )}
          >
            {value || '-'}
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default Detail;
